<section>
    <div class="mainDiv">
        <img src="../../../../assets/img/new-kidzee/pluce_img.png" class="pluce_icon_content" alt="">
        <div class="banner_content">
            <div class="whiteTitle">{{headerTitle}}</div>
            <div class="subMenu_content">
                <app-sub-menu></app-sub-menu>
            </div>
            
        </div>
        <img src="../../../../assets/img/new-kidzee/yellow_fish_color.png" class="fish_img_content" alt="">
     <div class="top_header">
      <img src="../../../../assets/img/new-kidzee/blog-top-bg-header.png" width="100%" alt="">
      <img src="../../../../assets/img/new-kidzee/girl_img.png" class="girl_img_content" alt="">
     </div>
     <div class="top_header_res">
        <img src="../../../assets/img/new-kidzee/banner/locut_us.png" width="100%" alt="">
         </div>
        <div class="subContent">
            <img src="../../../assets/img/new-kidzee/bag_img.png" class="bag_img_content" alt="">
            <img src="../../../assets/img/new-kidzee/chocolate_img.png" class="chocolate_img_content" alt="">
            <img src="../../../assets/img/new-kidzee/btrfly_img.png" class="btrfly_img_content" alt="">
            <img src="../../../assets/img/new-kidzee/fruit_img.png" class="fruit_img_content" alt="">
            <img src="../../../assets/img/new-kidzee/mouse_img.png" class="mouse_img_content" alt="">
            
            <div class="dropDownList">
                <form action="" [formGroup]="searchForm">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <select name="" id="" class="form-control  dropdown-toggle" formControlName="country"
                                    (change)="selectCountry($any($event.target).value)">

                                    <option value="{{country.Country_Id}}" *ngFor="let country of countryList">
                                        {{country.Country_Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3 res_input">
                            <div class="form-group">
                                <select name="" id="" class="form-control  dropdown-toggle" formControlName="state"
                                    (change)="selectState($any($event.target).value)">
                                    <option value="">State/District</option>
                                    <option value="{{state.State_Id}}" *ngFor="let state of stateList">
                                        {{state.State_Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3 res_input">
                            <div class="form-group">
                                <select name="" id="" class="form-control  dropdown-toggle" formControlName="city"
                                    (change)="selectCity($any($event.target).value)">
                                    <option value="">Select City</option>
                                    <option value="{{city.City_Id}}" *ngFor="let city of cityList">{{city.City_Name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3 res_input">
                            <div class="form-group">
                                <select name="" id="" class="form-control  dropdown-toggle" formControlName="location"
                                    (change)="selectLocation($any($event.target).value)">
                                    <option value="">Location</option>
                                    <option value="{{location.Franchisee_Code}}"
                                        *ngFor="let location of franchiseeList">{{location.Franchisee_Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row locut_us_list">
                <div class="col-md-4" *ngFor="let a of centerList">
            <div class="card_content mt-5">
                <div class="card_title">{{a.Franchisee_Name}}</div>
                <hr>
                <div class="location_content">
                    <div class="locationIcon">
                        <!-- <img srcset="../../../assets/img/location.png" loading="lazy" alt="" class="location_img"> -->
                        <p>{{a.Address1}},{{a.Address2}},{{a.Place}}</p>
                     
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="three_icon mt-3 phone_wp">
                              <div class="d-flex wp_icon">
                                <a  target="_blank"  href="https://wa.me/{{a.Mobile_No}}?text=I'm%20interested%20in%20your%20Kidzee centre%20for%20admission" *ngIf="a.Mobile_No!=''"><img src="../../../assets/img/WhatsApp Icon.png"
                                        class="iconList" loading="lazy" alt=""><span class="mx-2">{{a.Mobile_No}}</span></a>
                                        </div>
                                        <div class="d-flex">
                                <a href="tel:{{a.Mobile_No}}" *ngIf="a.Mobile_No!=''"><img src="../../../assets/img/Call Icon.png"
                                        class="iconList mx-3" loading="lazy" alt="">{{a.Mobile_No}}</a>
                                        </div>
                            </div>
                        </div>
                        <div class="col-12 display_flex">
                            <a href="https://www.google.com/maps/search/?api=1&query={{a.Latitude}},{{a.Longitude}}"
                                target="_blank"><button class="btn map_btn mt-3">Map Direction</button></a>
                            <button *ngIf="a.viewurl360!=''" class="btn map_btn mt-3" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                                (click)="openVirtualUrl(a.virtualurl)">Virtual Tour</button>
                            <button class="btn map_btn mt-3" (click)="setaddress(a)">Enquire Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        </div>
        <div class="showMore_content text-center mt-5">
            <label for="" class="count_label">Showing {{tindex}} records of {{this.totalrecord}}</label>
            <a class="showMore_btn" *ngIf="more" (click)="setcentrelistclick()">Show More</a>
        </div>
    </div>
    <!-- <div class="monkey_img_content">
        <img srcset="../../../../assets/img/monkeyWhithLight.png" loading="lazy" alt="" class="studying_monkey">
    </div> -->
</section>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <div class="">
                <div class="img_src">
                    <iframe width="100%" height="500px" style="border:0" loading="lazy" allowfullscreen
                        referrerpolicy="no-referrer-when-downgrade" [src]="virtual_url">
                    </iframe>

                </div>
            </div>
        </div>
    </div>
</div>
